import logoSrc from './UnaLogo.svg';

type UnaLogoProps = {
  className?: string;
};

export function UnaLogo({ className = '' }: UnaLogoProps) {
  return <img className={className} src={logoSrc} alt="Una Seguros" />;
}
